import { ComponentRef, Directive, effect, input, OnDestroy, Renderer2, ViewContainerRef } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `button[matButton][loading],
             button[mat-button][loading],
             button[mat-raised-button][loading],
             button[mat-icon-button][loading],
             button[mat-fab][loading],
             button[mat-fab][extended][loading],
             button[mat-mini-fab][loading],
             button[mat-stroked-button][loading],
             button[mat-flat-button][loading]`,
  standalone: true,
})
export class LoadingButtonDirective implements OnDestroy {
  loading$$ = input(false, { alias: 'loading' });
  disabled$$ = input(false, { alias: 'disabled' });

  private spinner: ComponentRef<MatProgressSpinner> | null = null;
  private readonly SPINNER_DIAMETER = 20;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer2,
  ) {
    effect(() => {
      if (this.loading$$()) {
        this.nativeElement.classList.add('loading');
        this.nativeElement.disabled = true;
        this.createSpinner();
      } else {
        this.nativeElement.classList.remove('loading');
        this.destroySpinner();
        this.nativeElement.disabled = this.disabled$$();
      }
    });
  }

  get nativeElement(): HTMLButtonElement {
    return this.viewContainerRef.element.nativeElement;
  }

  ngOnDestroy(): void {
    this.destroySpinner();
  }

  private createSpinner(): void {
    if (!this.spinner) {
      this.spinner = this.viewContainerRef.createComponent(MatProgressSpinner);
      this.spinner.instance.diameter = this.SPINNER_DIAMETER;
      this.spinner.instance.mode = 'indeterminate';
      this.renderer.appendChild(this.nativeElement, this.spinner.location.nativeElement);
    }
  }

  private destroySpinner(): void {
    if (this.spinner) {
      this.spinner.destroy();
      this.spinner = null;
    }
  }
}
